export type Language = [
  string, // key
  string, // name
]

/**
 * Fetches available languages for the logged-in user
 */
export function getLanguages(): Promise<Language[]> {
  return this.API.request('get_languages')
}
